module.exports = __webpack_public_path__ + "img/KINDERNINO-08.a0861e3d.jpg";